// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @media screen and (max-width:332px){
    .addcan-ac button{
        margin-bottom: 8px;
    }
} */

@media screen and (max-width:575px) {
    .changestatus-popup {
        width: 90vw !important;
    }

    .interview-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .popup-header-bg .d-flex {
        display: flex;
        flex-wrap: wrap;
    }

    .popup-header-bg .d-flex .p-component {
        margin-bottom: 4px;
    }

    .popup-header-bg .d-flex .preview-btn.ms-auto {
        margin: 0 auto !important;
    }

    .candidate-form .container-fluid {
        padding-right: 0px;
        padding-left: 0px;
    }

    .candidate-form .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 4px !important;
    }

    .footer.detailsformfooter .container-fluid {
        padding-right: 0px;
        padding-left: 0px;
    }

    .p-dialog .p-dialog-content {
        padding: 20px 20px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        padding: 0px 14px;
        margin-bottom: 0px;
        margin-top: 8px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .breadcrumb-card.addcandid-sec {
        display: flex;
        flex-wrap: wrap;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
        margin-right: 10px;
    }

    .view-form-sidebar.p-sidebar {
        width: 90vw;
    }

    .view-form-sidebar .pipelinetabs .p-tabview.p-component.p-tabview-scrollable {
        max-width: 700px !important;
        overflow: hidden;
    }

    .breadcrumb-card.addcandid-sec .action-items {
        margin-bottom: 10px;
    }

    .importres-sec {
        display: flex;
        flex-wrap: wrap;
        justify-content: start !important;
    }

    .importres-sec .action-items {
        margin-bottom: 10px;
    }

    .action-items button {
        /* margin-bottom: 10px !important; */
        font-size: 14px;
        line-height: 20px;
    }

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
        font-size: 14px;
        line-height: 20px;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
        font-size: 14px;
        line-height: 20px;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown span {
        font-size: 14px !important;
        line-height: 20px;
    }

    .action-items .p-dropdown .p-button-label span {
        font-size: 14px !important;
        line-height: 20px;
    }

    .print-actitems {
        display: block;
    }

    .action-items .p-fileupload {
        margin-bottom: 10px !important;
    }

    .canprint-actitems {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
    }

    .actjobsum .allbtns {
        display: flex;
        gap: .5rem !important;
        justify-content: start !important
    }

    .p-sidebar-right .p-sidebar {
        width: 80vw;
        height: 100%;
    }

    .address-popup.p-dialog.p-component {
        width: 85vw !important;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 80vw !important;
    }

    .p-component * {
        font-size: 14px;
    }

    .actjobsumtable .p-datatable .p-datatable-thead>tr>th {
        padding: 8px 8px 8px 8px;
    }

    .actjobsumtable .p-datatable .p-datatable-tbody>tr>td {
        padding: 8px 8px 8px 8px;
    }

    .allact-tabs .import-res-btn {
        font-size: 14px;
    }

    body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
        font-size: 14px;
    }

    #sidebar-menu ul li a {
        font-size: 15px;
    }

    .p-dialog .p-dialog-header .p-dialog-title {
        font-size: 18px;
    }

    .view-form-sidebar .tabview-sett .crudbtn {
        display: flex;
        flex-wrap: wrap;
    }

    .view-form-sidebar .tabview-sett .crudbtn .btn {
        margin-bottom: 6px;
    }

    .sett-popup .p-tabview .p-tabview-panels {
        padding: 0px;
    }

    .sett-popup.p-dialog .p-dialog-content {
        padding: 10px 20px 20px 20px;
    }

    .page-title-box .page-title {
        font-size: 20px;
    }

    .sidebar-header h3 {
        font-size: 18px;
    }

    .addfield-pop {
        font-size: 14px !important;
    }

    .header-pop {
        width: 85vw;
    }

    .advan-modal h4 {
        font-size: 14px !important;
    }

    .footer-tabsec {
        display: none;
    }

    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {
        padding: 0rem 0rem !important;
    }

    .footer-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .footer-back .gear-picklist {
        padding-top: 0px;
    }

    .footericons {
        padding-top: 10px;
    }

    /* 4-2-2025 */
    .clr-icons2 {
        display: block;
    }

    .clr-icons1 {
        display: none;
    }

    /* .icons-ac button{
        margin-bottom: 8px;
    } */
    /* .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
    .clr-icons {
        float: left;
    }

    /* .allact-tabs .drop-ac button {
        margin-bottom: 8px;
    } */
    /* .allact-tabs .drop-ac .import-res-btn{
        margin-bottom: 8px;
    } */
    /* 
    .addcan-ac button{
        margin-bottom: 8px;
    }
    .icons-ac button{
        margin-bottom: 8px;
    }
    .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */

    .link-candidates.p-dialog.p-component {
        width: 80vw !important;
    }

    .cand-details.p-dialog.p-component {
        width: 90vw !important;
    }

    .footer.footer-back {
        display: none;
    }
}

@media screen and (min-width:576px) and (max-width:767px) {
    .changestatus-popup {
        width: 70vw !important;
    }
    .interview-popup.p-dialog.p-component {
        width: 60vw !important;
    }

    .popup-header-bg .d-flex {
        display: flex;
        flex-wrap: wrap;
    }

    .popup-header-bg .d-flex .p-component {
        margin-bottom: 4px;
    }

    .popup-header-bg .d-flex .preview-btn.ms-auto {
        margin: 0 auto !important;
    }

    .footer.footer-back {
        display: none;
    }

    .link-candidates.p-dialog.p-component {
        width: 75vw !important;
    }

    .cand-details.p-dialog.p-component {
        width: 90vw !important;
    }

    .clr-icons {
        float: left;
    }

    .footer-tabsec {
        display: none;
    }

    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {
        padding: 0rem 0rem !important;
    }

    .footer-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .footer-back .gear-picklist {
        padding-top: 0px;
    }

    .footericons {
        padding-top: 10px;
    }

    .candidate-form .container-fluid {
        padding-right: 0px;
        padding-left: 0px;
    }

    .candidate-form .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 4px !important;
    }

    .footer.detailsformfooter .container-fluid {
        padding-right: 0px;
        padding-left: 0px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        padding: 0px 14px;
        margin-bottom: 0px;
        margin-top: 0px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .view-form-sidebar.p-sidebar {
        width: 90vw;
    }

    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .breadcrumb-card.addcandid-sec {
        display: flex;
        flex-wrap: wrap;
    }

    .breadcrumb-card.addcandid-sec .action-items {
        margin-bottom: 10px;
    }

    .importres-sec {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
    }

    .importres-sec .action-items {
        margin-bottom: 10px;
    }

    .action-items button {
        /* margin-bottom: 10px !important; */
        font-size: 14px;
        line-height: 20px;
    }

    .p-component * {
        font-size: 14px;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    /* .action-items button {
        margin-bottom: 10px !important;
    } */

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .print-actitems {
        display: block;
    }

    .canprint-actitems {
        display: flex;
        justify-content: start;
    }

    .p-sidebar-right .p-sidebar {
        width: 60vw;
        height: 100%;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        padding: 5px;
    }
    .nav-items {
        padding-top: 4px;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 75vw !important;
    }

    .actjobsumtable .p-datatable .p-datatable-thead>tr>th {
        padding: 8px 8px 8px 8px;
    }

    .actjobsumtable .p-datatable .p-datatable-tbody>tr>td {
        padding: 8px 8px 8px 8px;
    }

    .allact-tabs .import-res-btn {
        font-size: 14px;
    }

    body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
        font-size: 14px;
    }

    #sidebar-menu ul li a {
        font-size: 15px;
    }

    .p-dialog .p-dialog-header .p-dialog-title {
        font-size: 18px;
    }

    .sett-popup .p-tabview .p-tabview-panels {
        padding: 0px;
    }

    .page-title-box .page-title {
        font-size: 20px;
    }

    .sidebar-header h3 {
        font-size: 18px;
    }

    .header-pop {
        width: 80vw;
    }

    /* .addcan-ac button{
        margin-bottom: 8px;
    } */
    /* .icons-ac button{
        margin-bottom: 8px;
    } */
    /* .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
}

@media screen and (min-width:768px) and (max-width:991px) {

    .changestatus-popup {
        width: 70vw !important;
    }

    .popup-header-bg .d-flex {
        display: flex;
        flex-wrap: wrap;
    }

    .popup-header-bg .d-flex .p-component {
        margin-bottom: 4px;
    }

    .popup-header-bg .d-flex .preview-btn.ms-auto {
        margin: 0 auto !important;
    }

    .footer.footer-back {
        display: none;
    }

    .footer.footer-back {
        display: none;
    }

    .link-candidates.p-dialog.p-component {
        width: 70vw !important;
    }

    .cand-details.p-dialog.p-component {
        width: 90vw !important;
    }

    .clr-icons {
        float: left;
    }

    .footer-tabsec {
        display: none;
    }

    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {
        padding: 0rem 0rem !important;
    }

    .footer-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .footer-back .gear-picklist {
        padding-top: 0px;
    }

    .footericons {
        padding-top: 10px;
    }

    /* .addcan-ac button{
        margin-bottom: 8px;
    } */
    /* .icons-ac button{
        margin-bottom: 8px;
    } */
    /* .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
    .header-pop {
        width: 80vw;
    }

    .candidate-form .container-fluid {
        padding-right: 20px;
        padding-left: 20px;
    }

    .candidate-form .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 4px !important;
    }

    .footer.detailsformfooter .container-fluid {
        padding-right: 20px;
        padding-left: 20px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .view-form-sidebar.p-sidebar {
        width: 80vw;
    }

    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .breadcrumb-card.addcandid-sec {
        display: flex;
        flex-wrap: wrap;
    }

    .breadcrumb-card.addcandid-sec .action-items {
        margin-bottom: 10px;
    }

    .importres-sec {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
    }

    .importres-sec .action-items {
        margin-bottom: 10px;
    }

    /* 
    .action-items button {
        margin-bottom: 10px !important;
    } */

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .print-actitems {
        display: block;
    }

    .canprint-actitems {
        display: flex;
        justify-content: start;
    }

    .p-sidebar-right .p-sidebar {
        width: 60vw;
        height: 100%;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        padding: 5px;
    }

    .nav-items {
        padding-top: 4px;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 70vw !important;
    }
}

@media screen and (min-width:992px) and (max-width:1199px) {
    .changestatus-popup {
        width: 60vw !important;
    }

    .footer.footer-back {
        display: none;
    }

    .link-candidates.p-dialog.p-component {
        width: 65vw !important;
    }

    .cand-details.p-dialog.p-component {
        width: 85vw !important;
    }

    .clr-icons {
        float: left;
    }

    .footer-tabsec {
        display: none;
    }

    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {
        padding: 0rem 0rem !important;
    }

    .footer-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .footer-back .gear-picklist {
        padding-top: 0px;
    }

    .footericons {
        padding-top: 10px;
    }

    /* .addcan-ac button{
        margin-bottom: 8px;
    } */
    /* .icons-ac button{
        margin-bottom: 8px;
    } */
    /* .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
    .header-pop {
        width: 75vw;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }

    .nav-items1 {
        padding-top: 4px;
        padding-bottom: 4px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .view-form-sidebar.p-sidebar {
        width: 80vw;
    }

    .breadcrumb-card.addcandid-sec {
        display: flex;
        flex-wrap: wrap;
    }

    .breadcrumb-card.addcandid-sec .action-items {
        margin-bottom: 10px;
    }

    .importres-sec {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
    }

    .importres-sec .action-items {
        margin-bottom: 10px;
    }

    .print-actitems {
        display: block;
    }

    /* .action-items button {
        margin-bottom: 10px !important;
    } */

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .canprint-actitems {
        display: flex;
        justify-content: start;
    }

    .p-sidebar-right .p-sidebar {
        width: 45vw;
        height: 100%;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 70vw !important;
    }
}

@media screen and (min-width:1200px) and (max-width:1399px) {
    .footer.footer-back {
        display: none;
    }

    .link-candidates.p-dialog.p-component {
        width: 60vw !important;
    }

    .cand-details.p-dialog.p-component {
        width: 80vw !important;
    }

    .clr-icons {
        float: left;
    }

    .footer-tabsec {
        display: none;
    }

    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {
        padding: 0rem 0rem !important;
    }

    .footer-popup.p-dialog.p-component {
        width: 80vw !important;
    }

    .footer-back .gear-picklist {
        padding-top: 0px;
    }

    .footericons {
        padding-top: 10px;
    }

    /* .addcan-ac button{
        margin-bottom: 8px;
    } */
    /* .icons-ac button{
        margin-bottom: 8px;
    } */
    /* .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
    .header-pop {
        width: 60vw;
    }

    .importres-sec {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
    }

    .importres-sec .action-items {
        margin-bottom: 10px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }

    /* .action-items button {
        margin-bottom: 10px !important;
    } */

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .print-actitems {
        display: block;
    }

    .p-sidebar-right .p-sidebar {
        width: 40vw;
        height: 100%;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 70vw !important;
    }
}

@media screen and (min-width:1400px) and (max-width:1599px) {

    /* .addcan-ac button{
        margin-bottom: 8px;
    } */
    /* .icons-ac button{
        margin-bottom: 8px;
    }
    .drop-ac .p-cascadeselect{
        margin-bottom: 8px;
    } */
    .header-pop {
        width: 50vw;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }

    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
        margin-bottom: 10px;
    }

    .action-items button:not(:disabled).mainbtn.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items button.resbtn {
        margin-bottom: 0px !important;
    }

    .action-items .linkjobs {
        margin-bottom: 10px !important;
    }

    .action-items .p-dropdown {
        margin-bottom: 10px !important;
    }

    .print-actitems {
        display: block;
    }

    .p-sidebar-right .p-sidebar {
        width: 40vw;
        height: 100%;
    }

    .view-form-sidebar .p-tabview .p-tabview-nav {
        display: flex;
        flex-wrap: wrap;
    }

    .p-sidebar-right .view-form-sidebar.p-sidebar {
        width: 70vw !important;
    }
}

body,
button,
input,
select,
textarea,
.p-component,
.p-inputtext,
.p-dropdown,
.rdt_Table,
.rdt_TableHead,
.rdt_TableBody,
.rdt_TableCell,
.rdt_TableCol {
    font-family: "Plus Jakarta Sans", sans-serif !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,iCAAiC;IACrC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,aAAa;IACb;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;;OAEG;IACH;;OAEG;IACH;QACI,WAAW;IACf;;IAEA;;OAEG;IACH;;OAEG;IACH;;;;;;;;;OASG;;IAEH;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;;OAEG;;IAEH;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;;OAEG;IACH;;OAEG;IACH;;OAEG;AACP;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;OAEG;IACH;;OAEG;IACH;;OAEG;IACH;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;OAGG;;IAEH;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;OAEG;IACH;;OAEG;IACH;;OAEG;IACH;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;OAEG;;IAEH;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;OAEG;IACH;;OAEG;IACH;;OAEG;IACH;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;IACnB;;IAEA;;OAEG;;IAEH;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;;OAEG;IACH;;;;;OAKG;IACH;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;;;;;;;;;;;;IAaI,uDAAuD;AAC3D","sourcesContent":["/* @media screen and (max-width:332px){\n    .addcan-ac button{\n        margin-bottom: 8px;\n    }\n} */\n\n@media screen and (max-width:575px) {\n    .changestatus-popup {\n        width: 90vw !important;\n    }\n\n    .interview-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .popup-header-bg .d-flex {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .popup-header-bg .d-flex .p-component {\n        margin-bottom: 4px;\n    }\n\n    .popup-header-bg .d-flex .preview-btn.ms-auto {\n        margin: 0 auto !important;\n    }\n\n    .candidate-form .container-fluid {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .candidate-form .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-bottom: 4px !important;\n    }\n\n    .footer.detailsformfooter .container-fluid {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .p-dialog .p-dialog-content {\n        padding: 20px 20px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0px 14px;\n        margin-bottom: 0px;\n        margin-top: 8px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .breadcrumb-card.addcandid-sec {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n        margin-right: 10px;\n    }\n\n    .view-form-sidebar.p-sidebar {\n        width: 90vw;\n    }\n\n    .view-form-sidebar .pipelinetabs .p-tabview.p-component.p-tabview-scrollable {\n        max-width: 700px !important;\n        overflow: hidden;\n    }\n\n    .breadcrumb-card.addcandid-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .importres-sec {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: start !important;\n    }\n\n    .importres-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .action-items button {\n        /* margin-bottom: 10px !important; */\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown span {\n        font-size: 14px !important;\n        line-height: 20px;\n    }\n\n    .action-items .p-dropdown .p-button-label span {\n        font-size: 14px !important;\n        line-height: 20px;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    .action-items .p-fileupload {\n        margin-bottom: 10px !important;\n    }\n\n    .canprint-actitems {\n        display: flex;\n        justify-content: start;\n        flex-wrap: wrap;\n    }\n\n    .actjobsum .allbtns {\n        display: flex;\n        gap: .5rem !important;\n        justify-content: start !important\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 80vw;\n        height: 100%;\n    }\n\n    .address-popup.p-dialog.p-component {\n        width: 85vw !important;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 80vw !important;\n    }\n\n    .p-component * {\n        font-size: 14px;\n    }\n\n    .actjobsumtable .p-datatable .p-datatable-thead>tr>th {\n        padding: 8px 8px 8px 8px;\n    }\n\n    .actjobsumtable .p-datatable .p-datatable-tbody>tr>td {\n        padding: 8px 8px 8px 8px;\n    }\n\n    .allact-tabs .import-res-btn {\n        font-size: 14px;\n    }\n\n    body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n        font-size: 14px;\n    }\n\n    #sidebar-menu ul li a {\n        font-size: 15px;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-title {\n        font-size: 18px;\n    }\n\n    .view-form-sidebar .tabview-sett .crudbtn {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .view-form-sidebar .tabview-sett .crudbtn .btn {\n        margin-bottom: 6px;\n    }\n\n    .sett-popup .p-tabview .p-tabview-panels {\n        padding: 0px;\n    }\n\n    .sett-popup.p-dialog .p-dialog-content {\n        padding: 10px 20px 20px 20px;\n    }\n\n    .page-title-box .page-title {\n        font-size: 20px;\n    }\n\n    .sidebar-header h3 {\n        font-size: 18px;\n    }\n\n    .addfield-pop {\n        font-size: 14px !important;\n    }\n\n    .header-pop {\n        width: 85vw;\n    }\n\n    .advan-modal h4 {\n        font-size: 14px !important;\n    }\n\n    .footer-tabsec {\n        display: none;\n    }\n\n    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n        padding: 0rem 0rem !important;\n    }\n\n    .footer-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .footer-back .gear-picklist {\n        padding-top: 0px;\n    }\n\n    .footericons {\n        padding-top: 10px;\n    }\n\n    /* 4-2-2025 */\n    .clr-icons2 {\n        display: block;\n    }\n\n    .clr-icons1 {\n        display: none;\n    }\n\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n    .clr-icons {\n        float: left;\n    }\n\n    /* .allact-tabs .drop-ac button {\n        margin-bottom: 8px;\n    } */\n    /* .allact-tabs .drop-ac .import-res-btn{\n        margin-bottom: 8px;\n    } */\n    /* \n    .addcan-ac button{\n        margin-bottom: 8px;\n    }\n    .icons-ac button{\n        margin-bottom: 8px;\n    }\n    .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n\n    .link-candidates.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .cand-details.p-dialog.p-component {\n        width: 90vw !important;\n    }\n\n    .footer.footer-back {\n        display: none;\n    }\n}\n\n@media screen and (min-width:576px) and (max-width:767px) {\n    .changestatus-popup {\n        width: 70vw !important;\n    }\n    .interview-popup.p-dialog.p-component {\n        width: 60vw !important;\n    }\n\n    .popup-header-bg .d-flex {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .popup-header-bg .d-flex .p-component {\n        margin-bottom: 4px;\n    }\n\n    .popup-header-bg .d-flex .preview-btn.ms-auto {\n        margin: 0 auto !important;\n    }\n\n    .footer.footer-back {\n        display: none;\n    }\n\n    .link-candidates.p-dialog.p-component {\n        width: 75vw !important;\n    }\n\n    .cand-details.p-dialog.p-component {\n        width: 90vw !important;\n    }\n\n    .clr-icons {\n        float: left;\n    }\n\n    .footer-tabsec {\n        display: none;\n    }\n\n    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n        padding: 0rem 0rem !important;\n    }\n\n    .footer-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .footer-back .gear-picklist {\n        padding-top: 0px;\n    }\n\n    .footericons {\n        padding-top: 10px;\n    }\n\n    .candidate-form .container-fluid {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .candidate-form .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-bottom: 4px !important;\n    }\n\n    .footer.detailsformfooter .container-fluid {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 0px 14px;\n        margin-bottom: 0px;\n        margin-top: 0px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .view-form-sidebar.p-sidebar {\n        width: 90vw;\n    }\n\n    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .breadcrumb-card.addcandid-sec {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .breadcrumb-card.addcandid-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .importres-sec {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: start;\n    }\n\n    .importres-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .action-items button {\n        /* margin-bottom: 10px !important; */\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .p-component * {\n        font-size: 14px;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    /* .action-items button {\n        margin-bottom: 10px !important;\n    } */\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    .canprint-actitems {\n        display: flex;\n        justify-content: start;\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 60vw;\n        height: 100%;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 5px;\n    }\n    .nav-items {\n        padding-top: 4px;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 75vw !important;\n    }\n\n    .actjobsumtable .p-datatable .p-datatable-thead>tr>th {\n        padding: 8px 8px 8px 8px;\n    }\n\n    .actjobsumtable .p-datatable .p-datatable-tbody>tr>td {\n        padding: 8px 8px 8px 8px;\n    }\n\n    .allact-tabs .import-res-btn {\n        font-size: 14px;\n    }\n\n    body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n        font-size: 14px;\n    }\n\n    #sidebar-menu ul li a {\n        font-size: 15px;\n    }\n\n    .p-dialog .p-dialog-header .p-dialog-title {\n        font-size: 18px;\n    }\n\n    .sett-popup .p-tabview .p-tabview-panels {\n        padding: 0px;\n    }\n\n    .page-title-box .page-title {\n        font-size: 20px;\n    }\n\n    .sidebar-header h3 {\n        font-size: 18px;\n    }\n\n    .header-pop {\n        width: 80vw;\n    }\n\n    /* .addcan-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n}\n\n@media screen and (min-width:768px) and (max-width:991px) {\n\n    .changestatus-popup {\n        width: 70vw !important;\n    }\n\n    .popup-header-bg .d-flex {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .popup-header-bg .d-flex .p-component {\n        margin-bottom: 4px;\n    }\n\n    .popup-header-bg .d-flex .preview-btn.ms-auto {\n        margin: 0 auto !important;\n    }\n\n    .footer.footer-back {\n        display: none;\n    }\n\n    .footer.footer-back {\n        display: none;\n    }\n\n    .link-candidates.p-dialog.p-component {\n        width: 70vw !important;\n    }\n\n    .cand-details.p-dialog.p-component {\n        width: 90vw !important;\n    }\n\n    .clr-icons {\n        float: left;\n    }\n\n    .footer-tabsec {\n        display: none;\n    }\n\n    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n        padding: 0rem 0rem !important;\n    }\n\n    .footer-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .footer-back .gear-picklist {\n        padding-top: 0px;\n    }\n\n    .footericons {\n        padding-top: 10px;\n    }\n\n    /* .addcan-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n    .header-pop {\n        width: 80vw;\n    }\n\n    .candidate-form .container-fluid {\n        padding-right: 20px;\n        padding-left: 20px;\n    }\n\n    .candidate-form .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-bottom: 4px !important;\n    }\n\n    .footer.detailsformfooter .container-fluid {\n        padding-right: 20px;\n        padding-left: 20px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .view-form-sidebar.p-sidebar {\n        width: 80vw;\n    }\n\n    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .view-form-sidebar.canviewform .p-tabview .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .breadcrumb-card.addcandid-sec {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .breadcrumb-card.addcandid-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .importres-sec {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: start;\n    }\n\n    .importres-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    /* \n    .action-items button {\n        margin-bottom: 10px !important;\n    } */\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    .canprint-actitems {\n        display: flex;\n        justify-content: start;\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 60vw;\n        height: 100%;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        padding: 5px;\n    }\n\n    .nav-items {\n        padding-top: 4px;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 70vw !important;\n    }\n}\n\n@media screen and (min-width:992px) and (max-width:1199px) {\n    .changestatus-popup {\n        width: 60vw !important;\n    }\n\n    .footer.footer-back {\n        display: none;\n    }\n\n    .link-candidates.p-dialog.p-component {\n        width: 65vw !important;\n    }\n\n    .cand-details.p-dialog.p-component {\n        width: 85vw !important;\n    }\n\n    .clr-icons {\n        float: left;\n    }\n\n    .footer-tabsec {\n        display: none;\n    }\n\n    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n        padding: 0rem 0rem !important;\n    }\n\n    .footer-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .footer-back .gear-picklist {\n        padding-top: 0px;\n    }\n\n    .footericons {\n        padding-top: 10px;\n    }\n\n    /* .addcan-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n    .header-pop {\n        width: 75vw;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .nav-items1 {\n        padding-top: 4px;\n        padding-bottom: 4px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .view-form-sidebar.p-sidebar {\n        width: 80vw;\n    }\n\n    .breadcrumb-card.addcandid-sec {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .breadcrumb-card.addcandid-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .importres-sec {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: start;\n    }\n\n    .importres-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    /* .action-items button {\n        margin-bottom: 10px !important;\n    } */\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .canprint-actitems {\n        display: flex;\n        justify-content: start;\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 45vw;\n        height: 100%;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 70vw !important;\n    }\n}\n\n@media screen and (min-width:1200px) and (max-width:1399px) {\n    .footer.footer-back {\n        display: none;\n    }\n\n    .link-candidates.p-dialog.p-component {\n        width: 60vw !important;\n    }\n\n    .cand-details.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .clr-icons {\n        float: left;\n    }\n\n    .footer-tabsec {\n        display: none;\n    }\n\n    .footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n        padding: 0rem 0rem !important;\n    }\n\n    .footer-popup.p-dialog.p-component {\n        width: 80vw !important;\n    }\n\n    .footer-back .gear-picklist {\n        padding-top: 0px;\n    }\n\n    .footericons {\n        padding-top: 10px;\n    }\n\n    /* .addcan-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n    .header-pop {\n        width: 60vw;\n    }\n\n    .importres-sec {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: start;\n    }\n\n    .importres-sec .action-items {\n        margin-bottom: 10px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    /* .action-items button {\n        margin-bottom: 10px !important;\n    } */\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 40vw;\n        height: 100%;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 70vw !important;\n    }\n}\n\n@media screen and (min-width:1400px) and (max-width:1599px) {\n\n    /* .addcan-ac button{\n        margin-bottom: 8px;\n    } */\n    /* .icons-ac button{\n        margin-bottom: 8px;\n    }\n    .drop-ac .p-cascadeselect{\n        margin-bottom: 8px;\n    } */\n    .header-pop {\n        width: 50vw;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 8px;\n    }\n\n    .view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n        margin-bottom: 10px;\n    }\n\n    .action-items button:not(:disabled).mainbtn.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items button.resbtn {\n        margin-bottom: 0px !important;\n    }\n\n    .action-items .linkjobs {\n        margin-bottom: 10px !important;\n    }\n\n    .action-items .p-dropdown {\n        margin-bottom: 10px !important;\n    }\n\n    .print-actitems {\n        display: block;\n    }\n\n    .p-sidebar-right .p-sidebar {\n        width: 40vw;\n        height: 100%;\n    }\n\n    .view-form-sidebar .p-tabview .p-tabview-nav {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .p-sidebar-right .view-form-sidebar.p-sidebar {\n        width: 70vw !important;\n    }\n}\n\nbody,\nbutton,\ninput,\nselect,\ntextarea,\n.p-component,\n.p-inputtext,\n.p-dropdown,\n.rdt_Table,\n.rdt_TableHead,\n.rdt_TableBody,\n.rdt_TableCell,\n.rdt_TableCol {\n    font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
